import React, { useState, useEffect } from "react";

// DevExtreme components
import { TextBox } from 'devextreme-react';

const EMPTY = null;

export function PasswordWidget(props) {
  const { ui, data, writeBack, startWork } = props;
  const widgetId = ui.id;

  const [localContent, setLocalContent] = useState(EMPTY);
 
  let content = localContent !== EMPTY ? localContent : data && data.content ? data.content : "";
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    //console.log("PasswordWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const setContent = value => {
    setLocalContent(value);
    writeBack(encodeValue(value));
  };

  const encodeValue = value => {
    return btoa(value);
  }

  return (
    <TextBox
      id={widgetId}
      value={content}
      mode="password"
      onKeyUp={() => startWork()}
      onValueChanged={e => setContent(e.value)}
      readOnly={disabled}
      height={ui.controlHeight + "em"}
    />
  );
}
